export default {
  'planAccounts.domain.code': 'Código',
  'planAccounts.domain.description': 'Descrição',
  'planAccounts.domain.hierarchy': 'Hierarquia',
  'planAccounts.domain.destination': 'Natureza',
  'planAccounts.generateReport': 'Gerar Relatório',
  'planAccounts.modal.report.title': 'Gerar Relatório',
  'planAccounts.modal.report.buttons.pdf': 'Gerar PDF',
  'planAccounts.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'planAccounts.modal.report.buttons.csv': 'Gerar CSV',
  'planAccounts.modal.report.form.description': 'Descrição',
  'planAccounts.modal.report.form.destination': 'Natureza',
  'planAccounts.modal.report.form.nature': 'Natureza',
  'planAccounts.modal.report.form.destination.revenue': 'Receitas',
  'planAccounts.modal.report.form.destination.expense': 'Despesas',
  'planAccounts.modal.report.form.nature.income': 'Receitas',
  'planAccounts.modal.report.form.nature.expenses': 'Despesas',
  'planAccounts.modal.report.form.hierarchy': 'Hierarquia',
  'planAccounts.modal.report.form.hierarchy.synthetic': 'Sintética',
  'planAccounts.modal.report.form.hierarchy.analitical': 'Analítica',
  'planAccounts.modal.report.form.hierarchy.analytical': 'Analítica',
  'planAccounts.modal.general.new.title': 'Novo Plano de Contas',
  'planAccounts.modal.general.edit.title': 'Editar Plano de Contas',
  'planAccounts.modal.general.form.code': 'Código',
  'planAccounts.modal.general.form.description': 'Descrição',
  'planAccounts.modal.general.form.destination': 'Natureza',
  'planAccounts.modal.general.form.destination.revenue': 'Receitas',
  'planAccounts.modal.general.form.destination.expense': 'Despesas',
  'planAccounts.modal.general.form.hierarchy': 'Hierarquia',
  'planAccounts.modal.general.form.hierarchy.syntetics': 'Sintética',
  'planAccounts.modal.general.form.hierarchy.analitical': 'Analítica',
  'planAccounts.modal.general.form.planType': 'Tipo de Plano',
  'planAccounts.modal.general.form.planType.general': 'Geral',
  'planAccounts.modal.general.form.planType.tax': 'Imposto',
  'planAccounts.modal.general.form.planType.transfer': 'Transferência',
  'planAccounts.modal.general.form.planType.commission': 'Comissão',
  'planAccounts.modal.general.form.planType.estorno': 'Estorno',
  'planAccounts.modal.general.form.planType.tariff': 'Tarifa',
  'planAccounts.modal.general.form.classification': 'Tipo de Despesa',
  'planAccounts.modal.general.form.classification.fixed': 'Fixa',
  'planAccounts.modal.general.form.classification.variable': 'Variável',
  'planAccounts.modal.general.form.classification.withoutclassification':
    'Sem Classificação',

  'planAccounts.create.error':
    'Para criar o plano de contas, precisa-se criar a máscara nas configurações. ',
  'planAccounts.create': 'Criar Novo Plano de Contas',
  'planAccounts.create.notification.success': 'Sucesso',
  'planAccounts.create.notification.successDescription':
    'Plano de Contas criado.',

  'planAccounts.update': 'Editar Plano de Contas',
  'planAccounts.update.notification.success': 'Sucesso',
  'planAccounts.update.notification.successDescription':
    'Plano de Contas editado.',

  'planAccounts.remove': 'Remover Plano de Contas',
  'planAccounts.remove.alert':
    'Você realmente deseja remover o plano de contas:',
  'planAccounts.remove.notification.success': 'Sucesso',
  'planAccounts.remove.notification.successDescription':
    'Plano de Contas removida.',

  'planAccounts.filters.code': 'Código',
  'planAccounts.filters.description': 'Descrição',
  'planAccounts.filters.hierarchy': 'Hierarquia',
  'planAccounts.filters.destination': 'Natureza',

  'planAccounts.status.message.success':
    'Status do plano de contas alterado com sucesso!',

  'planAccounts.notification.generate.report.title':
    'Relatório gerado com sucesso',
  'planAccounts.notification.generate.report.description':
    'Relatório de Plano de Contas Gerado com Sucesso!',
};
